module.exports = __webpack_public_path__ + "static/media/sell_take_order_make_7.b46af3f0.jpg";